import {
  login, logout, resetPasswordMail, resetPassword,
  authVerify, getEmailChecking, postResendEmail, guestPersonalData,
  getAreaList, getIndustryList, getCompTradeRole, getDialCode, checkResetPwdExpired
} from '@/api/auth.api'
import { router } from '@/router'

export const POST_LOGIN = 'POST_LOGIN'
export const POST_LOGIN_LOADING = 'POST_LOGIN_LOADING'
export const POST_LOGIN_DONE = 'POST_LOGIN_DONE'
export const POST_LOGIN_ERROR = 'POST_LOGIN_ERROR'

export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_LOGOUT_LOADING = 'AUTH_LOGOUT_LOADING'
export const AUTH_LOGOUT_DONE = 'AUTH_LOGOUT_DONE'
export const AUTH_LOGOUT_ERROR = 'AUTH_LOGOUT_ERROR'

export const POST_PASS_MAIL = 'POST_PASS_MAIL'
export const POST_PASS_MAIL_LOADING = 'POST_PASS_MAIL_LOADING'
export const POST_PASS_MAIL_DONE = 'POST_PASS_MAIL_DONE'
export const POST_PASS_MAIL_ERROR = 'POST_PASS_MAIL_ERROR'

export const RESET_PASS = 'RESET_PASS'
export const RESET_PASS_LOADING = 'RESET_PASS_LOADING'
export const RESET_PASS_DONE = 'RESET_PASS_DONE'
export const RESET_PASS_ERROR = 'RESET_PASS_ERROR'

export const CHECK_RESET_PASS = 'CHECK_RESET_PASS'
export const CHECK_RESET_PASS_LOADING = 'CHECK_RESET_PASS_LOADING'
export const CHECK_RESET_PASS_DONE = 'CHECK_RESET_PASS_DONE'
export const CHECK_RESET_PASS_ERROR = 'CHECK_RESET_PASS_ERROR'

export const AUTH_VERIFY = 'AUTH_VERIFY'
export const AUTH_VERIFY_LOADING = 'AUTH_VERIFY_LOADING'
export const AUTH_VERIFY_DONE = 'AUTH_VERIFY_DONE'
export const AUTH_VERIFY_ERROR = 'AUTH_VERIFY_ERROR'

export const EMAIL_CHECK = 'EMAIL_CHECK'
export const EMAIL_CHECK_LOADING = 'EMAIL_CHECK_LOADING'
export const EMAIL_CHECK_DONE = 'EMAIL_CHECK_DONE'
export const EMAIL_CHECK_ERROR = 'EMAIL_CHECK_ERROR'

export const RESEND_EMAIL = 'RESEND_EMAIL'
export const RESEND_EMAIL_LOADING = 'RESEND_EMAIL_LOADING'
export const RESEND_EMAIL_DONE = 'RESEND_EMAIL_DONE'
export const RESEND_EMAIL_ERROR = 'RESEND_EMAIL_ERROR'

export const PUT_GUEST_DATA = 'PUT_GUEST_DATA'
export const PUT_GUEST_DATA_LOADING = 'PUT_GUEST_DATA_LOADING'
export const PUT_GUEST_DATA_DONE = 'PUT_GUEST_DATA_DONE'
export const PUT_GUEST_DATA_ERROR = 'PUT_GUEST_DATA_ERROR'

export const GET_LIST_AREA = 'GET_LIST_AREA'
export const GET_LIST_AREA_LOADING = 'GET_LIST_AREA_LOADING'
export const GET_LIST_AREA_DONE = 'GET_LIST_AREA_DONE'
export const GET_LIST_AREA_ERROR = 'GET_LIST_AREA_ERROR'

export const GET_LIST_INDUSTRY = 'GET_LIST_INDUSTRY'
export const GET_LIST_INDUSTRY_LOADING = 'GET_LIST_INDUSTRY_LOADING'
export const GET_LIST_INDUSTRY_DONE = 'GET_LIST_INDUSTRY_DONE'
export const GET_LIST_INDUSTRY_ERROR = 'GET_LIST_INDUSTRY_ERROR'

export const GET_LIST_TRADE_ROLE = 'GET_LIST_TRADE_ROLE'
export const GET_LIST_TRADE_ROLE_LOADING = 'GET_LIST_TRADE_ROLE_LOADING'
export const GET_LIST_TRADE_ROLE_DONE = 'GET_LIST_TRADE_ROLE_DONE'
export const GET_LIST_TRADE_ROLE_ERROR = 'GET_LIST_TRADE_ROLE_ERROR'

export const FETCH_DIAL_COUNTRY_CODE = 'FETCH_DIAL_COUNTRY_CODE'
export const FETCH_DIAL_COUNTRY_CODE_LOADING = 'FETCH_DIAL_COUNTRY_CODE_LOADING'
export const FETCH_DIAL_COUNTRY_CODE_DONE = 'FETCH_DIAL_COUNTRY_CODE_DONE'
export const FETCH_DIAL_COUNTRY_CODE_ERROR = 'FETCH_DIAL_COUNTRY_CODE_ERROR'

export default {
  [POST_LOGIN] (context, payload) {
    context.commit(POST_LOGIN_LOADING)
    return login(payload)
      .then(response => {
        context.commit(POST_LOGIN_DONE, response)
        localStorage.setItem('token', response.data.session.token)
        localStorage.setItem('profile', JSON.stringify(response.data.profile))
        if (localStorage.getItem('history') && ((localStorage.getItem('history') !== '/signin') || (localStorage.getItem('history') !== '/'))) {
          router.push(localStorage.getItem('history')).then(() => {})
          localStorage.removeItem('history')
        }
        if (response.data.profile.codeUserType === 'GUEST' && response.data.profile.isFirst === 1) {
          // user "Guest" and doesn't have personal data"
          router.push({name: 'GuestPersonalData'}).then(() => {})
        } 
        if (response.data.profile.codeUserType === 'GUEST' && response.data.profile.isFirst === 0) {
          // user "Guest" and has personal data"
          router.push({
            name: 'ManagementShipmentDetail',
            params: {
              id_shipment: response.data.profile.shipmentId,
              order_number: response.data.profile.orderNumber.split('/').join('-')
            }
          })
        }
        if (response.data.profile.status === 'ANDALINVERIFICATION') {
          router.push({name: 'Dashboard'}).then(() => {})
        } else {
          router.push({name: 'MyDocuments'}).then(() => {})
        }
      })
      .catch(error => {
        context.commit(POST_LOGIN_ERROR, error)
      })
  },

  [AUTH_LOGOUT] (context, { payload, profile, typeLogout }) {
    context.commit(AUTH_LOGOUT_LOADING)
    return logout(payload, typeLogout)
      .then(response => {
        context.commit(AUTH_LOGOUT_DONE, response)
        localStorage.clear()
        // force clear vuex
        window.location.href = '/signin'
      })
      .catch(error => {
        if (error && typeLogout === 'guest') {
          router.push({
            name: 'GuestSignIn',
            query: {
              shipment: profile.shipment,
              mail: profile.mail
            }
          })
          localStorage.clear()
        }
        context.commit(AUTH_LOGOUT_ERROR, error)
      })
  },

  [POST_PASS_MAIL] (context, payload) {
    context.commit(POST_PASS_MAIL_LOADING)
    return resetPasswordMail(payload)
      .then(response => {
        context.commit(POST_PASS_MAIL_DONE, response)
      })
      .catch(error => {
        context.commit(POST_PASS_MAIL_ERROR, error)
      })
  },

  [RESET_PASS] (context, payload) {
    context.commit(RESET_PASS_LOADING)
    return resetPassword(payload)
      .then(response => {
        context.commit(RESET_PASS_DONE, response)
      })
      .catch(error => {
        context.commit(RESET_PASS_ERROR, error)
      })
  },

  [CHECK_RESET_PASS] (context, payload) {
    context.commit(CHECK_RESET_PASS_LOADING)
    return checkResetPwdExpired(payload)
      .then(response => {
        context.commit(CHECK_RESET_PASS_DONE, response)
      })
      .catch(error => {
        context.commit(CHECK_RESET_PASS_ERROR, error)
      })
  },

  [AUTH_VERIFY] (context, payload) {
    context.commit(AUTH_VERIFY_LOADING)
    return authVerify(payload)
      .then(response => {
        context.commit(AUTH_VERIFY_DONE, response)
      })
      .catch(error => {
        context.commit(AUTH_VERIFY_ERROR, error)
      })
  },

  [EMAIL_CHECK] (context, payload) {
    context.commit(EMAIL_CHECK_LOADING)
    return getEmailChecking(payload)
      .then(response => {
        context.commit(EMAIL_CHECK_DONE, response)
      })
      .catch(error => {
        context.commit(EMAIL_CHECK_ERROR, error)
      })
  },

  [RESEND_EMAIL] (context, payload) {
    context.commit(RESEND_EMAIL_LOADING)
    return postResendEmail(payload)
      .then(response => {
        context.commit(RESEND_EMAIL_DONE, response)
      })
      .catch(error => {
        context.commit(RESEND_EMAIL_ERROR, error)
      })
  },

  [PUT_GUEST_DATA] (context, payload) {
    context.commit(PUT_GUEST_DATA_LOADING)
    return guestPersonalData(payload)
      .then(response => {
        context.commit(PUT_GUEST_DATA_DONE, response)
      })
      .catch(error => {
        context.commit(PUT_GUEST_DATA_ERROR, error)
      })
  },

  [GET_LIST_AREA] (context) {
    context.commit(GET_LIST_AREA_LOADING)
    return getAreaList()
      .then(response => {
        context.commit(GET_LIST_AREA_DONE, response)
      })
      .catch(error => {
        context.commit(GET_LIST_AREA_ERROR, error)
      })
  },

  [GET_LIST_INDUSTRY] (context) {
    context.commit(GET_LIST_INDUSTRY_LOADING)
    return getIndustryList()
      .then(response => {
        context.commit(GET_LIST_INDUSTRY_DONE, response)
      })
      .catch(error => {
        context.commit(GET_LIST_INDUSTRY_ERROR, error)
      })
  },

  [GET_LIST_TRADE_ROLE] (context) {
    context.commit(GET_LIST_TRADE_ROLE_LOADING)
    return getCompTradeRole()
      .then(response => {
        context.commit(GET_LIST_TRADE_ROLE_DONE, response)
      })
      .catch(error => {
        context.commit(GET_LIST_TRADE_ROLE_ERROR, error)
      })
  },

  [FETCH_DIAL_COUNTRY_CODE] (context) {
    context.commit(FETCH_DIAL_COUNTRY_CODE_LOADING)
    return getDialCode()
      .then((response) => {
        context.commit(FETCH_DIAL_COUNTRY_CODE_DONE, response.data)
      })
      .catch((error) => {
        context.commit(FETCH_DIAL_COUNTRY_CODE_ERROR, error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js